import React from 'react';

import { CommonStyles } from '~common/react/CommonStyles';

import { ILogo } from '../../../settings/siteLogo/services/LogoService';
import { Logo } from '../header/Logo';
import { SpacesSiteUrls } from '../spaceComponents/SpacesSiteUrls';
import { NavStyles } from './NavigationStyles';
import { LogoWrapperDivTestId } from './NavPanel';

export interface NavPanelLogoProps {
  logo: ILogo;
  compactLogo: ILogo;
  siteUrls: SpacesSiteUrls;
  collapsed: boolean;
  onClick?: () => void;
  disableLink?: boolean;
}

export const NavPanelLogo: React.SFC<NavPanelLogoProps> = (props: NavPanelLogoProps) => {
  const displayLogo = props.collapsed ? props.compactLogo : props.logo;
  displayLogo.styleOverrides = NavStyles.LogoImage;

  // we want the panel to not shift when expanding/collapsing, so we wrap a div fixed to the larger height of
  // the two logos so the logo area always stays the same.
  const biggerHeight = Math.max(props.logo.height, props.compactLogo.height);
  const wrappingDivStyle = {
    height: biggerHeight,
    marginTop: NavStyles.LogoMarginTop,
    marginBottom: NavStyles.LogoMarginBottom,
    ...CommonStyles.Layout.FlexBlockVerticalCenter
  };

  return (
    <div data-tb-test-id={LogoWrapperDivTestId} style={wrappingDivStyle}>
      <Logo siteUrls={props.siteUrls} logo={displayLogo} onClick={props.onClick} disableLink={props.disableLink}/>
    </div>
  );
};
